<app-busy-indicator></app-busy-indicator>

<app-youtube-video-popup #videoTutorial [src]="videoTutorialSrc"></app-youtube-video-popup>


<div *ngIf="isLoaded"
     [ngClass]="{'splash': stagesNavigationService.currentTab && stagesNavigationService.currentTab.splash}"
     class="workspace-container">

  <div class="info">
    <div class="header">

      <img alt="logo" class="logo hide-on-mobile" src="/img/logo-text.svg">

      <div class="show-on-mobile">
        <img *ngIf="!stagesNavigationService.currentTab.showInProgress()" alt="logo" class="logo"
             src="/img/logo-text.svg">
        <app-stages-navigation *ngIf="stagesNavigationService.currentTab.showInProgress()"
                               class="show-on-mobile"></app-stages-navigation>
      </div>

      <button (click)="videoTutorial.open()" class="guide">
        <span [innerHTML]="'Workspace.OpenTutorial' | translate | safe:'html'"></span>
        <img alt="guide" src="/img/guide.gif">
      </button>
    </div>

    <span
      [innerHTML]="'Workspace.' + stagesNavigationService.currentTab.applicationStatus + '.Title' | translate | safe:'html'"
      class="title hide-on-mobile"></span>
    <span
      [innerHTML]="'Workspace.' + stagesNavigationService.currentTab.applicationStatus + '.SubTitle' | translate | safe:'html'"
      class="sub-title"></span>

    <span
      [innerHTML]="'Workspace.' + stagesNavigationService.currentTab.applicationStatus + '.MobileTitle' | translate | safe:'html'"
      class="title show-on-mobile"></span>

    <img [src]="'/img/steps/step-1.png'" alt="step" class="step-img show-on-mobile">
    <img [src]="'/img/steps/step-' + stagesNavigationService.currentTab.step + '.png'" alt="step"
         class="step-img hide-on-mobile">
  </div>

  <div [ngClass]="{'splash': stagesNavigationService.currentTab && stagesNavigationService.currentTab.splash}"
       class="content">
    <app-stages-navigation class="hide-on-mobile"></app-stages-navigation>

    <div class="scroll-content">
      <router-outlet name="stages"></router-outlet>
    </div>

    <div *ngIf="stagesNavigationService.currentTab && stagesNavigationService.currentTab.splash !== true"
         class="buttons-container">
      <button (click)="back()" *ngIf="stagesNavigationService.canPrevious" class="back-button" mat-stroked-button>
        <svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_655_5432)">
            <path
              d="M16 0C7.175 0 0 7.175 0 16C0 24.825 7.175 32 16 32C24.825 32 32 24.825 32 16C32 7.175 24.825 0 16 0ZM16 30C8.28125 30 2 23.7188 2 16C2 8.28125 8.28125 2 16 2C23.7188 2 30 8.28125 30 16C30 23.7188 23.7188 30 16 30Z"
              fill="#7D8BAB"/>
            <path
              d="M22.7062 15.294C23.1 15.6877 23.1 16.3189 22.7062 16.7064L17.7062 21.7064C17.5125 21.9002 17.2563 22.0002 17 22.0002C16.7438 22.0002 16.4875 21.9002 16.2938 21.7064C15.9 21.3127 15.9 20.6815 16.2938 20.294L19.5875 17.0002H10C9.45 17.0002 9 16.5502 9 16.0002C9 15.4502 9.45 15.0002 10 15.0002H19.5875L16.2938 11.7065C15.9 11.3127 15.9 10.6815 16.2938 10.2939C16.6875 9.90645 17.3187 9.9002 17.7062 10.2939L22.7062 15.294Z"
              fill="#7D8BAB"/>
          </g>
          <defs>
            <clipPath id="clip0_655_5432">
              <rect fill="white" height="32" width="32"/>
            </clipPath>
          </defs>
        </svg>
      </button>

      <button (click)="updateUser()"
              *ngIf="!stagesNavigationService.isStage(['substitute', 'general-agreement'])"
              class="next-button"
              mat-stroked-button>
        {{ 'nextTabButton' | translate }}
        <img alt="next" class="next-icon" src="/img/next.svg">
      </button>

      <button (click)="updateUser()"
              *ngIf="stagesNavigationService.isStage(['substitute', 'general-agreement'])"
              class="next-button"
              mat-stroked-button>
        {{ 'iAgreeButton' | translate }}
        <img alt="next" class="next-icon" src="/img/next.svg">
      </button>
    </div>
  </div>
</div>
